import { useState } from "react";
import type { AutoRechargeRules, Invoice, UsageEvent } from "./types";

/** TODO(MIGRATION): swap mocks for real billing endpoints. UI must not change. */

const hrsAgo = (h: number) => new Date(Date.now() - h * 36e5).toISOString();

const MOCK_EVENTS: UsageEvent[] = [
  { id: "ev-1", timestamp: hrsAgo(1),  type: "batch_call", campaign: "Diwali_Recovery_Q3", durationSec: 134, amount: -12.5,  balanceAfter: 42168.05 },
  { id: "ev-2", timestamp: hrsAgo(2),  type: "batch_call", campaign: "Diwali_Recovery_Q3", durationSec: 96,  amount: -9.0,   balanceAfter: 42180.55 },
  { id: "ev-3", timestamp: hrsAgo(5),  type: "retry_call", campaign: "NBFC_Collections_T1", durationSec: 61, amount: -5.75,  balanceAfter: 42189.55 },
  { id: "ev-4", timestamp: hrsAgo(9),  type: "adhoc_call", campaign: null, durationSec: 204, amount: -19.0,  balanceAfter: 42195.3 },
  { id: "ev-5", timestamp: hrsAgo(24), type: "platform_fee", campaign: null, durationSec: null, amount: -500, balanceAfter: 42214.3 },
  { id: "ev-6", timestamp: hrsAgo(30), type: "batch_call", campaign: "Healthcare_Renewal", durationSec: 151, amount: -14.2, balanceAfter: 42714.3 },
  { id: "ev-7", timestamp: hrsAgo(49), type: "top_up", campaign: null, durationSec: null, amount: 20000, balanceAfter: 42728.5 },
  { id: "ev-8", timestamp: hrsAgo(52), type: "batch_call", campaign: "KYC_Verification", durationSec: 342, amount: -31.5, balanceAfter: 22728.5 },
];

const MOCK_INVOICES: Invoice[] = [
  { id: "INV-2026-08", period: "Aug 2026 (month-to-date)", issuedAt: "—", amount: 4210.0, status: "pending" },
  { id: "INV-2026-07", period: "Jul 2026", issuedAt: "Aug 01, 2026", amount: 15400.0, status: "paid" },
  { id: "INV-2026-06", period: "Jun 2026", issuedAt: "Jul 01, 2026", amount: 12850.0, status: "paid" },
  { id: "INV-2026-05", period: "May 2026", issuedAt: "Jun 01, 2026", amount: 9980.0,  status: "paid" },
];

export function useBilling() {
  const [events] = useState<UsageEvent[]>(MOCK_EVENTS);
  const [invoices] = useState<Invoice[]>(MOCK_INVOICES);
  const [rules, setRules] = useState<AutoRechargeRules>({ enabled: true, threshold: 5000, amount: 20000 });

  return {
    events,
    invoices,
    rules,
    saveRules: (next: AutoRechargeRules) => setRules(next), // TODO: real mutation
  };
}
